// extracted by mini-css-extract-plugin
export var root = "splash-module--root--Yljq3";
export var logo = "splash-module--logo--OnThq";
export var link = "splash-module--link--BHWCq";